if (document.querySelector('.intro')) {
    // const vs = document.querySelectorAll('.video-background')
    // const main = document.querySelector('main')
    // main.addEventListener('scroll', () => {
    //     vs.forEach(v => {
    //         if (window.innerHeight - main.scrollTop < 300) {
    //             v.classList.add('video-background--disabled')
    //             v.style.height = window.innerHeight - main.scrollTop + 'px'
    //         } else {
    //             v.style.height = window.innerHeight - main.scrollTop + 'px'
    //             v.classList.remove('video-background--disabled')
    //         }
    //     });
    // })
    const footer = document.querySelector('.footer');
    const header = document.querySelector('.header')
    window.addEventListener('scroll', () => {
        if (window.scrollY > 0) {
            footer.classList.remove('transparent')
            header.classList.remove('transparent')
        } else {
            footer.classList.add('transparent')
            header.classList.add('transparent')
        }
    })
}